export class User {}

export class AppUser {}

export class UserAccess {
    [x: string]: any;
    constructor(
        public id: string,
        public companyName: string,
        public roleName: string,
        public role: any
    ) {}
}

export class UserPermission {}

export class UserStore {
    avatar: string | ArrayBuffer;
}
